import { render, staticRenderFns } from "./knowledge-dialog.vue?vue&type=template&id=651f8674&scoped=true"
import script from "./knowledge-dialog.vue?vue&type=script&lang=js"
export * from "./knowledge-dialog.vue?vue&type=script&lang=js"
import style0 from "./knowledge-dialog.vue?vue&type=style&index=0&id=651f8674&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651f8674",
  null
  
)

export default component.exports